"use client";

import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/auth-context";

export function HeroSection() {
  const locale = useLocale();
  const t = useTranslations("hero");
  const tCommon = useTranslations("common");
  const { isAuthenticated } = useAuth();

  return (
    <section className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/10 via-background to-accent/10 border border-border p-8 md:p-12">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5" />
      
      <div className="relative z-10 max-w-3xl">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-4 text-balance">
          {t("title")}
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground mb-8 text-pretty">
          {t("subtitle")}
        </p>
        
        <div className="flex flex-wrap gap-4">
          {isAuthenticated ? (
            <Button size="lg" onClick={() => document.getElementById("tools-section")?.scrollIntoView({ behavior: "smooth" })}>
              {t("exploreTools")}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          ) : (
            <>
              <Button asChild size="lg">
                <Link href={`/${locale}/login`}>
                  {tCommon("signIn")}
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg">
                <Link href={`/${locale}/register`}>
                  {tCommon("createAccount")}
                </Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
